/* IVY | Global Big Brand Sale fallback — never duplicates an eligible Zoorix block. */
(function(){
  'use strict';
  function start(){
    var box=document.getElementById('ivy-big-brand-fallback');
    if(!box||!document.body.classList.contains('template-product'))return;
    function existingSaleWidget(){
      return Array.from(document.querySelectorAll('.zrx-widget-slider .zrx-frequently-bought-together')).some(function(widget){
        if(!widget.isConnected||getComputedStyle(widget).display==='none')return false;
        var count=Number(widget.getAttribute('data-ivy-sale-count'));
        if(Number.isFinite(count)&&count>0)return true;
        return Array.from(widget.querySelectorAll('.zrx-slider-list-item[data-ivy-sale-keep="1"]')).some(function(card){
          return card.isConnected&&getComputedStyle(card).display!=='none';
        });
      });
    }
    function place(){
      if(!box.classList.contains('ivy-big-brand-fallback--ready'))return;
      var vg=document.getElementById('ivy-vergani-festive');
      if(vg&&vg.classList.contains('ivy-vergani-festive--ready')&&vg.parentNode){
        if(box.nextElementSibling!==vg)vg.insertAdjacentElement('beforebegin',box);
        return;
      }
      var submit=document.querySelector('.product__submit:not(.cart-bar__submit)');
      var form=submit&&submit.closest('form.product-form');
      if(form&&form.parentElement&&box.previousElementSibling!==form){
        form.insertAdjacentElement('afterend',box);
      }
    }
    function update(){
      var show=!existingSaleWidget();
      if(box.classList.contains('ivy-big-brand-fallback--ready')!==show){
        box.classList.toggle('ivy-big-brand-fallback--ready',show);
      }
      if(show)place();
    }
    // Allow the asynchronous Zoorix widget to finish loading first.
    [1300,2600,5000,9000,16000].forEach(function(delay){setTimeout(update,delay)});
    var planned=false;
    var observer=new MutationObserver(function(){
      if(planned)return;planned=true;
      requestAnimationFrame(function(){planned=false;update()});
    });
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-ivy-sale-count','class','style']});
    setTimeout(function(){observer.disconnect();update()},25000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
